export default {
  UPDATE_STATE: "global/UPDATE_STATE",
  INIT_STATE: "global/INIT_STATE"
};
